/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import Dots from '../../../components/Loading/Dots';
import { GET_ADMIN_AGENT_STATISTIC } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import ArrowdownIcon from '../../../svgs/ArrowdownIcon';
import ArrowupIcon from '../../../svgs/ArrowupIcon';
import Styles from './RealtortrackingDashboard.module.scss';

const RealtorTrackingDashboard = () => {
  const [getAgentStatistics, agentStatisticsLoading, agentMiniStatistics] = useCustomQuery({
    query: GET_ADMIN_AGENT_STATISTIC,
    onError: () => {},
    onData: () => {},
  });

  const dashboardDetails = agentMiniStatistics?.getAdminAgentStatistic?.data;

  console.log('agentStatisticsLoading', agentStatisticsLoading);

  const details = [
    {
      id: 1,
      title: 'Total realtors',
      count: dashboardDetails?.totalRealtors || 0,
      isIncrease: !(dashboardDetails?.totalRealtorsPercentageChange < 0),
      time: 'last month',
      percentage: dashboardDetails?.totalRealtorsPercentageChange || 0,
    },
    {
      id: 2,
      title: 'Codes generated',
      count: dashboardDetails?.codes || 0,
      isIncrease: !(dashboardDetails?.totalCodesPercentageChange < 0),
      time: 'last month',
      percentage: dashboardDetails?.totalCodesPercentageChange || 0,
    },
  ];

  useEffect(() => {
    getAgentStatistics();
  }, []);

  return (
    <div className={Styles.wrapper}>
      <div className="row">
        {
          details?.map((list) => (
            <div key={list?.id} className="col-md-6 col">

              {/* {agentStatisticsLoading && <div className={Styles.wrapper__detailsLoader}><Dots /></div> } */}

              <div className={Styles.wrapper__container}>
                {
                  agentStatisticsLoading && (
                  <div className={Styles.wrapper__loaderContainer}>
                    <div className={Styles.wrapper__detailsLoader}><Dots /></div>
                  </div>
                  )
                }

                {
                  !agentStatisticsLoading && (
                    <>

                      <div className={Styles.wrapper__title}>{list?.title}</div>
                      <div className={Styles.wrapper__count}>{list?.count}</div>

                      <div className={Styles.wrapper__stage}>
                        <span>
                          {
                            list?.isIncrease ? <ArrowupIcon /> : <ArrowdownIcon />
                          }
                        </span>
                        <span className={list?.isIncrease ? Styles.wrapper__arrowUp : Styles.wrapper__arrowDown}>
                          {
                            `${list?.percentage}%`
                          }
                        </span>

                        <span className={Styles.wrapper__time}>
                          vs
                          {' '}
                          {list?.time}
                        </span>

                      </div>
                    </>
                  )
                }
              </div>

            </div>
          ))
        }

      </div>
    </div>
  );
};

export default RealtorTrackingDashboard;
